(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.initialized) return;
    const data = root.querySelector('[data-bm-models]');
    if (!data) return;
    let models;
    try { models = JSON.parse(data.textContent); } catch { return; }
    root.dataset.initialized = 'true';
    const tabs = Array.from(root.querySelectorAll('.model-tab'));
    const setText = (id, value) => { const node = root.querySelector('#' + id); if (node) node.textContent = value; };
    function select(tab, focus) {
      const model = models[tab.dataset.model];
      if (!model) return;
      tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
      const panel = root.querySelector('#model-panel');
      panel.setAttribute('aria-labelledby', tab.id);
      ['name', 'tagline', 'description', 'price', 'compare', 'save', 'availability'].forEach(key => setText('model-' + key, model[key] || ''));
      const img = root.querySelector('#model-image'); img.src = model.image; img.alt = model.alt;
      const specs = root.querySelector('#model-specs');
      const nodes = model.specs.map(([value, label]) => { const div = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = value; dd.textContent = label; div.append(dt, dd); return div; });
      specs.replaceChildren(...nodes);
      const link = root.querySelector('#model-link'); link.href = model.url; link.setAttribute('aria-label', model.linkLabel); link.querySelector('[data-link-label]').textContent = model.linkLabel;
      root.querySelector('.model-footnote').hidden = tab.dataset.model !== 'gm3';
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else return;
        event.preventDefault(); select(tabs[next], true);
      });
    });
    select(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0], false);
  }
  const start = () => document.querySelectorAll('#bm-homepage').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
